import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const authRequest = createAction(types.AUTH_REQUEST);
export const authSuccess = createAction(types.AUTH_SUCCESS);
export const authFailure = createAction(types.AUTH_FAILURE);

export const oktaRedirect = createAction(types.OKTA_REDIRECT);

export const redirectIfLoggedIn = createAction(types.REDIRECT_REQUEST);

export const accessDealerRequest = createAction(types.ACCESS_DEALER_REQUEST);
export const accessDealerSuccess = createAction(types.ACCESS_DEALER_SUCCESS);
export const accessDealerFailure = createAction(types.ACCESS_DEALER_FAILURE);

export const accessAdminRequest = createAction(types.ACCESS_ADMIN_REQUEST);
export const accessAdminSuccess = createAction(types.ACCESS_ADMIN_SUCCESS);
export const accessAdminFailure = createAction(types.ACCESS_ADMIN_FAILURE);

export const logoutRequest = createAction(types.LOGOUT_REQUEST);

export const otpVerifyRequest = createAction(types.OTP_VERIFY_REQUEST);
export const otpResendRequest = createAction(types.OTP_RESEND_REQUEST);

export const expireSessionRequest = createAction(types.EXPIRE_SESSION_REQUEST);

export default {
  authRequest,
  authSuccess,
  authFailure,
  oktaRedirect,
  redirectIfLoggedIn,
  accessDealerRequest,
  accessDealerSuccess,
  accessDealerFailure,
  accessAdminRequest,
  accessAdminSuccess,
  accessAdminFailure,
  logoutRequest,
  otpVerifyRequest,
  otpResendRequest,
  expireSessionRequest,
};
